<template>
  <div class="main-board__footer main-content__footer sm-only" v-if="eventPrice">
    <div class="main-board__left">
      <div class="main-board__price-text">
        цена
      </div>
      <div class="main-board__prices">
        <div class="main-board__price-cross-out" v-if="currentEvent.discount || currentEvent.discountMembersCount || currentEvent.discountPromoSum || currentEvent.discountPromoPercent">
          {{ currentEvent.priceFormatted }} <span v-html="currencySymbol"></span>
        </div>
        <div class="main-board__price">
          {{ eventPrice.toLocaleString() }}&nbsp;<span v-html="currencySymbol"></span>
        </div>
      </div>
      <div class="main-board__price-after" v-if="currentEvent.discount">
        Скидка за покупку билета заранее
      </div>
      <div class="main-board__price-after" v-if="currentEvent.discountMembersCount">
        Скидка за кол-во человек в поездке
      </div>
    </div>
    <div class="main-board__right">
      <span v-if="convertedPrice">{{ convertedPrice? convertedPrice.toLocaleString() : 0 }} <p class="rouble">&#8381;</p></span>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: "MobilePrice",
    computed: {
      ...mapState([
        'currentEvent'
      ]),
      ...mapGetters([
        'currencySymbol',
        'eventPrice',
        'convertedPrice'
      ])
    }
  }
</script>

<style scoped>

</style>
